if(!customElements.get('custom-collection-banner')){
    class CustomCollectionBanner extends HTMLElement {
      constructor(){
        super();

        this.init();
      }
      
      init(){
        if(this.closest('.shopify-section') == document.querySelector('main').querySelectorAll('.shopify-section')[0]){
          var header = document.querySelector('custom-header');
          if(header){
            var headerHeight = header.offsetHeight;

            this.querySelector('.collection-banner__content-wrapper').style.paddingTop = `${headerHeight}px`;
            this.querySelector('.collection-banner__content-wrapper').classList.remove('py-5');
            this.querySelector('.collection-banner__content-wrapper').classList.add('pb-5');
          }
        }
      }

      refresh(){
        this.init();
      }
    }

    customElements.define('custom-collection-banner', CustomCollectionBanner);
}